module.exports = __webpack_public_path__ + "static/media/emissions.9b309e42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/icons/emissions.svg
// module id = 365
// module chunks = 0